import { Days } from 'constants/enums';

// export const mealTypeOptions = [
//   { value: 'Breakfast', label: 'Breakfast' },
//   { value: 'Lunch/Dinner', label: 'Lunch/Dinner' },
//   { value: 'Snack', label: 'Snack' },
//   { value: 'Dessert', label: 'Dessert' },
//   { value: 'Sauces/Dressings/Dips', label: 'Sauces/Dressings/Dips' },
//   { value: 'Drinks', label: 'Drinks' },
//   { value: 'Salads', label: 'Salads' },
// ];

// export const feelingTypeOptions = [
//   { value: 'Leaner & Lighter', label: 'Leaner & Lighter' },
//   { value: 'Grounding', label: 'Grounding' },
//   { value: 'Detoxifying', label: 'Detoxifying' },
//   { value: 'Energizing', label: 'Energizing' },
// ];

// export const collections = [
//   'Plant-based',
//   'High in protein',
//   'Meal prep friendly',
//   'Quick to make',
//   'Beginner friendly',
// ];

// export const timeOptions = [
//   { value: '5 min', label: '5 min' },
//   { value: '10-20 min', label: '10-20 min' },
//   { value: '20-30 min', label: '20-30 min' },
//   { value: 'over 30 min', label: 'over 30 min' },
// ];

// export const amountOptions = [
//   { value: '3/4', label: '3/4' },
//   { value: '1/4', label: '1/4' },
//   { value: '1/2', label: '1/2' },
//   { value: '1', label: '1' },
//   { value: '2', label: '2' },
//   { value: '3', label: '3' },
//   { value: '4', label: '4' },
//   { value: '5', label: '5' },
// ];

// export const amountTypeOptions = [
//   { value: 'tsp', label: 'tsp' },
//   { value: 'tbsp', label: 'tbsp' },
//   { value: 'cup', label: 'cup' },
//   { value: 'pack', label: 'pack' },
//   { value: 'pinch', label: 'pinch' },
//   { value: 'bunch', label: 'bunch' },
//   { value: 'piece', label: 'piece' },
//   { value: 'ml', label: 'ml' },
//   { value: 'gm', label: 'gm' },
// ];

export const DAYS = [
  Days.Sunday,
  Days.Monday,
  Days.Tuesday,
  Days.Wednesday,
  Days.Thursday,
  Days.Friday,
  Days.Saturday,
];
